module.exports = __webpack_public_path__ + "img/logo-small.c859aff1.svg";